import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import Search from "../assets/search.png";
import FilterIcon from "../assets/filterIcon.png";
import { ArrowLeft } from "lucide-react";
import { GuestManagementPageText } from "../CommonJquery/WebsiteText.js";
import {
  server_post_data,
  get_car_report,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  computeTodayDate,
  computeplussevendays,
  goBack,
  formatToYYYYMMDD,
  sortByCarTaglineAscending,
} from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
function CarsReport() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  // Set initial state using useState hook
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [flagData, setflagData] = useState("1");
  const [selectedValue, setSelectedValue] = useState("Name"); // State to hold the selected value
  const handleSelect = (event) => {
    setSelectedValue(event.target.value); // Update the selected value when an option is selected
  };
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const statusData = [
    { value: " ", label: "All" },
    { value: "Available", label: "Available" },
    { value: "Booked", label: "Booked" },
    { value: "Taxi", label: "Taxi" },
    { value: "Repair", label: "Repair" },
    { value: "Bodywork", label: "Bodywork" },
    { value: "Isurance", label: "Isurance" },
    { value: "Test", label: "Test" },
    { value: "New", label: "New" },
    { value: "Assigned", label: "Assigned" },
    { value: "Sale", label: "Sale" },
    { value: "Standby", label: "Standby" },
  ];

  const handleStatusFilterChange = (status) => {
    console.log(status);

    if (status == " ") {
      setfilteredData(filteredData); // Reset to all data
    } else {
      console.log(allData);
      const filtered = allData.filter((item) => item.car_status == status);
      setfilteredData(filtered);
      console.log(filtered);
    }
  };

  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = sortByCarTaglineAscending(filteredData)
  const currentItems = filteredData
    ? sortByCarTaglineAscending(filteredData).slice(
        indexOfFirstItem,
        indexOfLastItem
      )
    : [];
  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  //console.log("currentItems:", currentItems);

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  }, []);

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    setCurrentPage(1);
    master_data_get(startDate, endDate, flag, call_id);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("end_date", formatToYYYYMMDD(end_date));
    // fd.append("flag", flag);
    // fd.append("call_id", call_id);
    // fd.append("search_option", selectedValue);
    // fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_car_report, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          console.log("Console:", Response.data.message);

          seteditStaffData(Response.data.message.enquiry_data);
          setfilteredData(Response.data.message.enquiry_data);
          setAllData(Response.data.message.enquiry_data);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchFilter(searchValue);
    setCurrentPage(1);

    const filteredDatashow = editStaffData.filter((row) => {
      // const car = row.driver_details?.[0] || {};

      const fieldsToSearch = [
        row.car_status,
        row.insurance_company,
        row.make_year,
        row.car_tagline, // fleet number
        row.car_name,
        row.car_no,
        row.vin,
      ];

      return fieldsToSearch.some((field) =>
        field?.toString().toLowerCase().includes(searchValue)
      );
    });

    setfilteredData(filteredDatashow);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  const downloadMaintenanceCSV = () => {
    const headers = [
      "Fleet No.",
      "Plate No.",
      "Make Year",
      "Car Name",
      "VIN",
      "Status",
      "Status Notes",
      "Oil Level",
      "Insu Company",
    ];

    const rows = filteredData.map((item) => [
      item.car_tagline || "",
      item.make_year || "",
      item.car_no || "",
      item.car_name || "",
      item.vin || "",
      item.car_status || "",
      item.car_status_notes || "",
      item.insurance_company || "",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows]
        .map((row) =>
          row.map((field) => `"${String(field).replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "maintenance_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <p className="breadcrumb-item">Cars Report</p>
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
              <div className={` alignCol bottomAlgin col-xl-3 mb-0`}>
                <div className="pageActionBtns">
                  <button
                    className="CSVBTN"
                    style={{ height: "38px" }}
                    onClick={downloadMaintenanceCSV}
                  >
                    Download Excel
                  </button>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="col-lg-3 col-sm-4 bottomAlgin">
                      <div className="inputDiv2">
                        <label style={{ whiteSpace: "nowrap" }}>
                          <img src={FilterIcon} alt="Rapid Car Leasing" />
                        </label>
                        <select
                          onChange={(e) =>
                            handleStatusFilterChange(e.target.value)
                          }
                        >
                          {statusData.map((status) => (
                            <option key={status.value} value={status.value}>
                              {status.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div
                      className="col-xl-3 col-md-4 bottomAlgin"
                      style={{ marginLeft: "auto", marginRight: "0" }}
                    >
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={Search} alt="Rapid Car Leasing" />
                        </label>
                        <input
                          type="text"
                          placeholder={GuestManagementPageText.Guest_Filter}
                          value={searchfilter}
                          // onInput={handleIaphabetnumberChange}
                          onChange={(e) => handleSearch(e)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card" style={{ padding: "0 10px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col">Fleet No.</th>
                              <th scope="col">Make Year</th>
                              <th scope="col">Plate No.</th>
                              <th scope="col">Car Name</th>
                              <th scope="col">VIN</th>
                              <th scope="col">Status</th>
                              <th scope="col">Status Note</th>
                              <th scope="col">Insu Company</th>
                              <th scope="col">Px</th>
                              <th scope="col">RL</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems && currentItems.length > 0 ? (
                              currentItems.map((option, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText justify-content-start height50 historyName"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option.car_tagline}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option.make_year}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option.car_no}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option.car_name}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option.vin}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      <strong>{option?.car_status}</strong>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.car_status_notes}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {option?.insurance_company}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {/* {option?.insurance_company} */}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText justify-content-start height50 historyName">
                                      {/* {option?.insurance_company} */}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div className="cust_hist_card_footer">
                          <div className="cust_hist_pagination_info">
                            {filteredData && filteredData.length > 0 ? (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  {indexOfFirstItem + 1}
                                </span>{" "}
                                to{" "}
                                <span className="cust_hist_pagination_bold">
                                  {Math.min(
                                    indexOfLastItem,
                                    filteredData.length
                                  )}
                                </span>{" "}
                                of{" "}
                                <span className="cust_hist_pagination_bold">
                                  {filteredData.length}
                                </span>{" "}
                                Drivers
                              </>
                            ) : (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  0
                                </span>{" "}
                                Driver
                              </>
                            )}
                          </div>
                          <div className="cust_hist_pagination">
                            <nav aria-label="Pagination">
                              <ul className="cust_hist_pagination_list">
                                {renderPaginationButtons()}
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CarsReport;
